import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from "../../interceptor/axiosInstance";
import NotificationService from "../Utils/NotificationService";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import "./Register.css";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      code: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters long")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/\d/, "Password must contain at least one number"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: async (payload, { resetForm }) => {
      const code = searchParams.get("d");
      payload.code = code;

      try {
        const response = await axiosInstance.post(`/auth/reset-password`, payload);
        if (response?.data?.error === "USER NOT FOUND") {
          NotificationService.error("Invalid Reset Link!");
        } else {
          resetForm();
          setSuccessMessage("Password successfully reset! Redirecting to login in 5 seconds...");
          setTimeout(() => { navigate("/login"); }, 5000);
        }
      } catch (err) {
        NotificationService.error("An error occurred while resetting the password.");
      }
    },
  });

  return (
    <div className="auth-page">
      {/* Background Orbs */}
      <div className="bg-orbs">
        <div className="orb-1"></div>
        <div className="orb-2"></div>
      </div>

      <div className="auth-card">
        <Link to="/">
          <img src="/ezzDesk_Logo.svg" alt="EzzDesk Logo" className="auth-logo" />
        </Link>
        <h1 className="auth-title" style={{ marginBottom: '10px' }}>Reset Password</h1>
        <p style={{ color: '#475569', marginBottom: '30px', fontSize: '15px' }}>
          Enter your new password below.
        </p>

        {successMessage && (
          <div style={{
            background: 'rgba(22, 163, 74, 0.08)',
            border: '1px solid rgba(22, 163, 74, 0.25)',
            borderRadius: '12px',
            padding: '14px 18px',
            color: '#15803d',
            fontSize: '14px',
            fontWeight: 500,
            marginBottom: '20px',
            textAlign: 'center',
          }}>
            ✅ {successMessage}
          </div>
        )}

        <form onSubmit={formik.handleSubmit} className="auth-form" noValidate>
          <div>
            <input
              id="password"
              name="password"
              type="password"
              placeholder="Enter New Password"
              className="auth-input"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.password && formik.errors.password && (
              <span className="text-danger">{formik.errors.password}</span>
            )}
          </div>

          <div>
            <input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              placeholder="Confirm New Password"
              className="auth-input"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.confirmPassword && formik.errors.confirmPassword && (
              <span className="text-danger">{formik.errors.confirmPassword}</span>
            )}
          </div>

          <div style={{ fontSize: '13px', color: '#475569', marginTop: '-5px' }}>
            <ul style={{ paddingLeft: '20px', margin: '5px 0' }}>
              <li>6 characters minimum</li>
              <li>At least one number</li>
              <li>Upper & lowercase character</li>
            </ul>
          </div>

          <button type="submit" className="auth-button">
            Reset Password
          </button>
        </form>

        <div className="auth-footer">
          <p><Link to="/login" className="auth-link">Return to Sign In</Link></p>
          <p style={{ marginTop: '10px' }}><Link to="/register" className="auth-link">Don't have an account?</Link></p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
